"use client";

import { useState } from "react";
import Search from "@/components/ui/Search";
import UsedProductsFiltersContainer from "@/components/usedProducts/UsedProductsFiltersContainer";
import UsedProductsFeatured from "@/components/usedProducts/UsedProductsFeatured";
import UsedProductsList from "@/components/usedProducts/UsedProductsList";
import { Pagination } from "@/components/common";
import { UsedProductFamily, UsedProductIndustry, UsedProductsFeatureds } from "@/@types";
import { UsedProductsList as UsedProductList } from "@/@types";
interface Props {
    usedProductsListResponse:  UsedProductList;
    usedProductsFeaturedResponse: UsedProductsFeatureds[];
    usedProductsFamilyResponse: UsedProductFamily[];
    usedProductsIndustryResponse: UsedProductIndustry[];
}

export default function UsedProductsContainer({
    usedProductsListResponse,
    usedProductsFeaturedResponse,
    usedProductsFamilyResponse,
    usedProductsIndustryResponse,
}: Props) {
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const toggleFilterModal = () => setIsFilterModalOpen((prev) => !prev);

    return (
        <div className="grid grid-cols-1 lg:grid-cols-[25%_75%]">
            <div className="flex flex-col gap-4">
                <Search onOpenFilters={toggleFilterModal} />
                <UsedProductsFiltersContainer
                    usedProductIndustry={usedProductsIndustryResponse}
                    usedProductFamily={usedProductsFamilyResponse}
                    isMenuOpen={isFilterModalOpen}
                    toggleMenu={toggleFilterModal}
                />
            </div>
            <div className="lg:pl-4">
                <UsedProductsFeatured usedProductsFeatured={usedProductsFeaturedResponse} />
                <UsedProductsList usedProductsList={usedProductsListResponse} />
                <Pagination
                    result="Productos"
                    currentPage={usedProductsListResponse.meta.currentPage}
                    lastPage={usedProductsListResponse.meta.lastPage}
                    totalResults={usedProductsListResponse.meta.total}
                    perPage={usedProductsListResponse.meta.perPage}
                />
            </div>
        </div>
    );
}
